import { type List } from 'immutable';
import React, { type ReactNode } from 'react';

import BackstageAlbumGridItem from './BackstageAlbumGridItem';
import BackstageGrid from './BackstageGrid';

export interface IBackstageAlbumGridOwnProps {
  pandoraIds: List<string>;
  numPlaceholders?: number;
  isDisabled?: boolean;
}

export type IBackstageAlbumGridProps = IBackstageAlbumGridOwnProps;

class BackstageAlbumGrid extends React.Component<IBackstageAlbumGridProps> {
  render(): ReactNode {
    let listBackstageAlbums = this.props.pandoraIds;

    if (this.props.numPlaceholders && this.props.numPlaceholders <= listBackstageAlbums.size) {
      listBackstageAlbums = listBackstageAlbums.setSize(this.props.numPlaceholders);
    }

    return (
      <BackstageGrid>
        {/* @ts-expect-error TS(7006) FIXME: Parameter 'pandoraId' implicitly has an 'any' type... Remove this comment to see the full error message */}
        {listBackstageAlbums.map((pandoraId: string, index): $TSFixMe => {
          return (
            <BackstageAlbumGridItem
              pandoraId={pandoraId}
              key={`${index}-${pandoraId}`}
              isDisabled={this.props.isDisabled}
            />
          );
        })}
      </BackstageGrid>
    );
  }
}

export default BackstageAlbumGrid;
